import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';

export interface OrderDetailsItemProps {
  field: string;
  value: string | number;
}

export const OrderDetailsItem: React.FC<OrderDetailsItemProps> = ({ field, value }) => {
  const classes = useStyles();

  return (
    <Box paddingBottom={10}>
      <Typography className={classes.labelField}>{field}</Typography>
      <Box flex={1} display="flex" alignItems="center" className={classes.valueContainer}>
        <Typography className={classes.value}>{value}</Typography>
      </Box>
    </Box>
  );
};
